import MobileHomeHotMessageLimit2 from './MobileHomeHotMessageLimit2'
export default MobileHomeHotMessageLimit2;
